<div class="modal active performanceOpt">
  <div class="modal__container modal__container--sm">
    <div class="fields">
      <h2>Performance Options</h2>
      <div class="close" (click)="cancel()"><img src="/assets/img/close-white.svg" alt="" /></div>
      <div class="fields__container">
        <form autocomplete="off"  class="active" id="ngForm" name="ngForm" #ngForm="ngForm">
          <div class="fields__block">
            <div class="fields__block__section">
              <div class="title">
                <h4>Layer Settings</h4>
                <span> </span>
              </div>
              <div class="input-fields">
                <div class="form-group">
                  <label for="">Calculation Name</label>
                  <input id="test" name="calculationName" type="text" [(ngModel)]="calculationControlService.performanceDTOModel.name" [required]="true"
                  #calculationName="ngModel" alphaNumeric forbiddenSubstring={{forbiddenCalculationSubstring}}/>
                  <span class="error" *ngIf="calculationName.errors?.forbiddenName">
                    Name cannot contain {{forbiddenCalculationSubstring}}.
                  </span>
                  <span class="error" *ngIf=" (calculationName.dirty || calculationName.touched) && calculationName.errors?.nonAlphaNumeric">
                    Only alphanumeric characters, hyphens and underscores are allowed.
                  </span>
                </div>
              </div>
            </div>
            <div class="fields__block__section">
              <div class="title">
                <h4>Calculation Mode</h4>
                <span> </span>
              </div>
              <div class="input-fields">
                <div>
                  <input type="checkbox" [checked]="calculationControlService.performanceDTOModel.isSingleLevel" (change)="changeSelection()"/>
                  <label for="">Use Single Level</label>
                </div>
              </div>
            </div>
            <div class="fields__block__section">
              <div class="title">
                <h4>Single Altitude Parameteres (AMSL)</h4>
                <span> </span>
              </div>
              <div class="input-fields">
                <div>
                  <label for="">Single Level Altitude</label>
                  <div class="coordenates">
                    <input id="singleLevelAltitudeFeet" name="singleLevelAltitudeFeet" #singleLevel='ngModel' [(ngModel)]="calculationControlService.performanceDTOModel.flightLevel"
                    (ngModelChange)="calculationControlService.performanceDTOModel.flightLevelMeters=pointsController.convertToMeters($event)"
                    type="number" style="width: 30%" [required]="calculationControlService.performanceDTOModel.isSingleLevel" [disabled]="!calculationControlService.performanceDTOModel.isSingleLevel"/><span>[ft]</span>
                    <input id="singleLevelAltitudeMeters" name="singleLevelAltitudeMeters" [(ngModel)]="calculationControlService.performanceDTOModel.flightLevelMeters"
                    (ngModelChange)="calculationControlService.performanceDTOModel.flightLevel=pointsController.convertToFeet($event)"
                    type="number" style="width: 30%" [required]="calculationControlService.performanceDTOModel.flightLevel" [disabled]="!calculationControlService.performanceDTOModel.isSingleLevel"/><span>[m]</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="fields__block__section">
              <div class="title">
                <h4>Alt. Range Parameteres (AMSL)</h4>
                <span> </span>
              </div>
              <div class="input-fields">
                <div>
                  <label for="">Max Altitude</label>
                  <div class="coordenates">
                    <input id="maxAltitudeAltitudeFeet" name="maxAltitudeAltitudeFeet" type="number" #maxAltitude='ngModel' [(ngModel)]="calculationControlService.performanceDTOModel.maxAltitude"
                    (ngModelChange)="calculationControlService.performanceDTOModel.maxAltitudeMeters=pointsController.convertToMeters($event)"
                    style="width: 30%" [required]="!calculationControlService.performanceDTOModel.isSingleLevel" [disabled]="calculationControlService.performanceDTOModel.isSingleLevel"/><span>[ft]</span
                    ><input id="maxAltitudeAltitudeMeters" name="maxAltitudeAltitudeMeters" [(ngModel)]="calculationControlService.performanceDTOModel.maxAltitudeMeters"
                    (ngModelChange)="calculationControlService.performanceDTOModel.maxAltitude=pointsController.convertToFeet($event)"
                    type="number" style="width: 30%" [required]="!calculationControlService.performanceDTOModel.isSingleLevel" [disabled]="calculationControlService.performanceDTOModel.isSingleLevel"/><span>[m]</span>
                  </div>
                </div>
                <div>
                  <label for="">Min Altitude</label>
                  <div class="coordenates">
                    <input id="minAltitudeFeet" name="minAltitudeFeet" #minAltitude='ngModel' [(ngModel)]="calculationControlService.performanceDTOModel.minAltitude"
                    (ngModelChange)="calculationControlService.performanceDTOModel.minAltitudeMeters=pointsController.convertToMeters($event)"
                    type="number" style="width: 30%" [required]="!calculationControlService.performanceDTOModel.isSingleLevel" [disabled]="calculationControlService.performanceDTOModel.isSingleLevel"/><span>[ft]</span
                    ><input id="minAltitudeMeters" name="minAltitudeMeters" [(ngModel)]="calculationControlService.performanceDTOModel.minAltitudeMeters"
                    (ngModelChange)="calculationControlService.performanceDTOModel.minAltitude=pointsController.convertToFeet($event)"
                    type="number" style="width: 30%" [required]="!calculationControlService.performanceDTOModel.isSingleLevel" [disabled]="calculationControlService.performanceDTOModel.isSingleLevel"/><span>[m]</span>
                  </div>
                </div>
                <div>
                  <label for="">Altitude Increment</label>
                  <div class="coordenates">
                    <input id="altitudeIncrementFeet" name="altitudeIncrementFeet" #altitudeIncrement='ngModel' [(ngModel)]="calculationControlService.performanceDTOModel.altitudeInterval"
                    (ngModelChange)="calculationControlService.performanceDTOModel.altitudeIntervalMeters=pointsController.convertToMeters($event)"
                    type="number" style="width: 30%" [required]="!calculationControlService.performanceDTOModel.isSingleLevel" [disabled]="calculationControlService.performanceDTOModel.isSingleLevel"/><span>[ft]</span
                    ><input id="altitudeIncrementMeters" name="altitudeIncrementMeters" [(ngModel)]="calculationControlService.performanceDTOModel.altitudeIntervalMeters"
                    (ngModelChange)="calculationControlService.performanceDTOModel.altitudeInterval=pointsController.convertToFeet($event)"
                    type="number" style="width: 30%" [required]="!calculationControlService.performanceDTOModel.isSingleLevel" [disabled]="calculationControlService.performanceDTOModel.isSingleLevel"/><span>[m]</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="fields__block">
            <div class="fields__block__section" *ngIf="isUserAdmin()">
              <div class="title">
                <h4>Polygons</h4>
                <span> </span>
              </div>
              <div class="input-fields">
                <div *ngIf="endpointService.isUserAdmin()">
                 <input type="checkbox" [checked]="calculationControlService.performanceDTOModel.isSupressOverlappingPolygons" (change)="changeSupressSelection()"/>
                 <label for="" style="width: auto;">Supress Overlapping Polygons</label>
                </div>
                <div>
                  <input type="checkbox" [checked]="calculationControlService.performanceDTOModel.isSimplifyPolygons" (change)="changeSimplifySelection()"/>
                  <label for=""  style=" width: auto;">Simplify Polygons</label>
                </div>
              </div>
            </div>
            <div class="fields__block__section">
                <div class="title">
                  <h4>DME-DME Calculation Type</h4>
                  <span> </span>
                </div>
                <div class="input-fields input-fields--col-2">
                  <div>
                    <input type="checkbox" [checked]="calculationControlService.performanceDTOModel.isRedundancy" (change)="changeRedundanceSelection()" [disabled]="true"/>
                    <label for=""  style=" width: auto;">Redundancy</label>
                  </div>
                  <div>
                    <input type="checkbox" [checked]="calculationControlService.performanceDTOModel.isSubtendedAngles" (change)="changeSubtendedAngleSelection()"/>
                    <label for=""  style=" width: auto;">Subtended Angle</label>
                  </div>
                  <div>
                    <input type="checkbox" [checked]="calculationControlService.performanceDTOModel.isNSE" (change)="changeNSESelection()"/>
                    <label for=""  style=" width: auto;">NSE</label>
                  </div>
                  <div>
                    <input type="checkbox" [checked]="calculationControlService.performanceDTOModel.isAvailablePairs" (change)="changeAvailablePairsSelection()"/>
                    <label for=""  style=" width: auto;">Available Pairs</label>
                  </div>
                </div>
            </div>
          </div>
          <div class="fields__btn" style="padding:10px 20px;">
            <button
              type="submit"
              [ngClass]="ngForm.form.valid ? 'blue' : 'gray'"
              (click)="performanceCalculationDME(); ngForm.reset()"
              [disabled]="!ngForm.form.valid"
            >
              DME-DME
            </button>
            <button
              type="submit"
              [ngClass]="ngForm.form.valid ? 'blue' : 'gray'"
              (click)="performanceCalculationVOR(); ngForm.reset()"
              [disabled]="!ngForm.form.valid"
            >
              VOR-DME
            </button>
            <button class="gray" type="reset" (click)="cancel()" value="Cancel">Cancel</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
